import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../../../common';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  private datePipe = new DatePipe('en-US');

  constructor() { }

  transform(value: string | Date): string | null {
    const format = Constants.DATE_FORMAT || 'mediumDate'; // default format
    return this.datePipe.transform(value, format);
  }
}
